import addressApi from './axiosClient'

export default {
  checkLogin: data => {
    return addressApi.post(`auth/refresh-token`, data)
  },
}
